<template>
  <section class='collapsible-section' :class='{"collapsed": sectionCollapsed, "_p0 has-sub-section": isSubSection }'>
    <app-section-header>
      <template #text>
        <slot name='headerText'></slot>
      </template>
      <template #actions>
        <slot name='headerActionsRight'></slot>
        <collapse-button
          v-if="$props.collapsible"
          ref='collapseButton'
          @onToggle='sectionCollapseToggled'
          :initiallyCollapsed='sectionCollapsed'
          class='_bl0'
          :is-collapse-button-disabled="isCollapseButtonDisabled"
        />
        <slot name='headerActions'></slot>
      </template>
    </app-section-header>
    <transition
      v-on:enter="enter"
      v-on:leave="leave">
      <div v-if='!sectionCollapsed && !memberBenefitsToggled' class="drawer">
      <section
        class='_p0 content'
        :class="isSubSection ? `_pts _pbs` : ''"
      >
        <slot name='collapsibleSection'/>
      </section>
      </div>
    </transition>
  </section>
</template>

<script>
  import CollapseButton from '@molecules/CollapseButton'
  import AppSectionHeader from '@organisms/SectionHeader'
  import accordionTransition from '@mixins/accordionTransition'
  export default {
    components: {
      CollapseButton,
      AppSectionHeader
    },
    props: {
      collapsed: {
        type: Boolean,
        default: false
      },
      collapsible: {
        type: Boolean,
        default: true
      },
      isSubSection: {
        type: Boolean,
        default: false,
        required: false
      },
      isCollapseButtonDisabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data() {
      return {
        sectionCollapsed: this.$props.collapsed,
        memberBenefitsToggled: false
      }
    },
    mixins: [accordionTransition],
    methods: {
      expand () {
        this.sectionCollapsed = true
      },
      collapse () {
        this.sectionCollapsed = false
      },
      sectionCollapseToggled (collapsed) {
        this.sectionCollapsed = collapsed

        if (!this.sectionCollapsed) {
          this.$emit('collapseOthers')
        }
        if (this.$attrs.sectionName == 'Benefits') {
          this.memberBenefitsToggled = true
          this.$emit('benefitsToggled', this.sectionCollapsed)
        }
      }
    },
    watch: {
      collapsed(newVal) {
        this.sectionCollapsed = newVal
      }
    }
  }
</script>

<style lang="scss" scoped>
  .has-sub-section /deep/ .advanced-table section {
    padding: 0 !important;
  }
</style>
